module.exports = __webpack_public_path__ + "static/img/jian.80e100e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jian.png
// module id = Ky+O
// module chunks = 73